module.exports = __webpack_public_path__ + "img/exchange_1.74e62167.svg";